import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getGroups, getInactiveSitesAPI, getPagedDevicesAPI } from "../../Api Methods/Api";
import { Await, useNavigate } from "react-router-dom";
import DevicesList from "../../components/GridList/DevicesList";
import DataManager from "../../hooks/DataManager";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import classes from '../OfflineSites/offlineSites.module.css'
import Stats2 from "../../components/UI/Stats/Stats2";
import SearchBar from "../SearchView/Search/SearchBar";
import { filter } from "rxjs";
import ActiveSitesSearchbar from "../ActiveSites/activeSitesSearchbar";
import mixpanel from "mixpanel-browser";

const Controllers = () => {

  const [controllers, setControllers] = useState([]);

  //const [activeSites, setActiveSites] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingStats, setIsLoadingStats] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")
  const [filteredData, setFilteredData] = useState([])
  const dataManager = new DataManager();

  const [totalPages, setTotalPages] = useState([])
  const [resultCount, setResultCount] = useState(0)
  const [onlineCount, setOnlineCount] = useState(0)
  const [offlineCount, setOfflineCount] = useState(0)
  const [noUserCount, setNoUserCount] = useState(0)


  const [totalDevices, setTotalDevices] = useState([])
  const [pageOffset, setPageOffset] = useState(0)
  const dispatch = useDispatch();
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
  const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
  const [update, setUpdate] = useState(0)
  const [showMassSettings, setShowMassSettings] = useState(false)

  const [selectedFilter, setSelectedFilter] = useState("")
  const [sortBy, setSortBy] = useState([])
  const [page, setPage] = useState(1);
  const [visibleDevices, setVisibleDevices] = useState([]);
  
  const [groups, setGroups] = useState([])
  const [selectedGroupFilter, setSelectedGroupFilter] = useState([])
  const [portalSiteNameFilter, setPortalSiteNameFilter] = useState("")
  const [includes, setIncludes] = useState(true)

  const [active, setActive] = useState(null)
  const [online, setOnline] = useState(0)
  const [offline, setOffline] = useState(0)
  const [deviceTag, setDeviceTag] = useState(null)
  const [deviceType, setDeviceType] = useState(1)
  const [groupName, setGroupName] = useState(null)
  const [noTag, setNoTag] = useState(0)

  const [submit, setSubmit] = useState(0)

  const [showLoadMore, setShowLoadMore] = useState(true)

  const prevBody = useRef();

  const apiData = {
      token,
      client
  }

  const getSites = async (body) => {
      const response = await getInactiveSitesAPI(apiData, body, dispatch)
      console.log(response)
      setControllers(response.data[1])
      setResultCount(response.data[0][0].totalCount)
      setOnlineCount(response.data[0][0].onlineControllers)
      setOfflineCount(response.data[0][0].offlineControllers)
      setNoUserCount(response.data[0][0].noUserControllers)
      setFilteredData(response.data[1])
      setTotalPages(Math.ceil(response.data[0][0].totalCount / pageSize));
      setIsLoading(false)
      setIsLoadingStats(false)
  }

  const GetGroups = async () => {
      try {
          const listOptions = await getGroups(apiData, dispatch);
          console.log(listOptions);
          setGroups(listOptions || []);
      } catch (error) {
          console.error('Failed to fetch groups:', error);
          setGroups([]);
      }
  }

  useEffect(() => {
    GetGroups();

    mixpanel.track("Controllers tab visited", {
      user: localStorage.getItem('email')
    });

  }, [])

  useEffect(() => {
    setIsLoading(true)
    const offset = pageSize * (pageFetchedIndex -1); 
    setPageOffset(offset);

    console.log("Offset:", offset);

      let body = {
          "active": -1,
          "pageSize": pageSize,
          "pageOffset": offset,
          "online": online,
          "offline": offline, 
          "deviceTag": deviceTag,
          "deviceType": deviceType,
          "groupName": groupName,
          "noTag": noTag,
          "searchTerm": searchTerm
      }

      console.log(body)

      getSites(body)

      const timer = setTimeout(() => {
        if (prevBody.current && (JSON.stringify(body) !== JSON.stringify(prevBody.current))) {
            mixpanel.track("Controllers search performed", {
                user: localStorage.getItem('email'),
                body: body
            });
        }
        prevBody.current = body;
      }, 2000);
      return () => clearTimeout(timer);
  }, [submit, pageSize, pageFetchedIndex, online, offline, deviceTag, deviceType, groupName, noTag])

  useEffect(() => {
    const delay = setTimeout(() => {
      // Trigger a refresh via submit or whatever you use
      setSubmit(prev => !prev); 
    }, 400); // 300–500ms debounce recommended
  
    return () => clearTimeout(delay);
  }, [searchTerm]);

  return (
    <>
    
    <div style={{ width: "100%"}}>
              <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
              
                      <Stats2
                          title={"All controller count"}
                          value={resultCount}
                          isLoadingStats={isLoadingStats}
                          isStatic={true}
                      />
                      <Stats2
                        title={"Online controllers"}
                        value={onlineCount}
                        isLoadingStats={isLoadingStats}
                        isStatic={true}
                      />
                      <Stats2
                        title={"Offline controllers"}
                        value={offlineCount}
                        isLoadingStats={isLoadingStats}
                        isStatic={true}
                      />
                      <Stats2
                        title={"Controllers with no users"}
                        value={noUserCount}
                        isLoadingStats={isLoading}
                        isStatic={true}
                      />
                
              </div>
          </div>

          <div className={classes.searchContainer}>

              <ActiveSitesSearchbar
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  showFilterButton={true}
                  groups={groups}
                  online={online}
                  setOnline={setOnline}
                  offline={offline}
                  setOffline={setOffline}
                  deviceTag={deviceTag}
                  setDeviceTag={setDeviceTag}
                  deviceType={deviceType}
                  setDeviceType={setDeviceType}
                  groupName={groupName}
                  setGroupName={setGroupName}
                  submit={submit}
                  setSubmit={setSubmit}
                  noTag={noTag}
                  setNoTag={setNoTag}
                  isControllers={true}
                  style={{
                      padding: "10px", 
                      width: "300px",    
                      fontSize: "14px",  
                      boxSizing: "border-box", 
                      borderRadius: "4px",
                  }}/>

              {searchTerm !== "" && <div>
                  <p>{filteredData.length} results</p>
              </div>}
            </div>


      <Await resolve={controllers}>
        {(loadedControllers) => {
          return (
            <>
            <div style={{ width: "100%"}}>
            {isLoading ? (
              <div style={{ display: "flex", width: "100%" }}>
                <DeviceLoadingGrid
                  CardCount={
                    20
                  }
                />
              </div>
            ) : (
              <>
            
              <DevicesList
                devices={loadedControllers}
                filtering={""}
                hideControls={false}
                totalPages={totalPages}
                setTotalPages={setTotalPages}
                pageFetchedIndex={pageFetchedIndex}
                setPageFetchedIndex={setPageFetchedIndex}
                pageSize={pageSize}
                setPageSize={setPageSize}
                totalDevices={resultCount}
                setTotalDevices={setTotalDevices}
                groupMode={false}
                update={update}
                setUpdate={setUpdate}
                offlineOnly={false}
                isSortable={true}
                showMassSelect={true}
                showMassSettings={showMassSettings}
                setShowMassSettings={setShowMassSettings}
                
              />
              </>
              
            )}
          </div>
          </>
          )
        }}
      </Await>
      </>
    )
}

  //   const dataManager = new DataManager();
  //   const [sites, setSites] = useState([])
  //   const [offlineSites, setOfflineSites] = useState([])
  //   const [onlineSites, setOnlinesites] = useState([])
  //   const [sitesNoUsers, setsitesNoUsers] = useState([])
  //   const [totalPages, setTotalPages] = useState([])
  //   const [totalDevices, setTotalDevices] = useState([])
  //   const [isLoading, setIsLoading] = useState(true)
  //   const [update, setUpdate] = useState(0)
  //   const navigate = useNavigate();
  //   const dispatch = useDispatch();
  //   const client = useSelector(state => state.auth.client);
  //   const token = useSelector(state => state.auth.token);
  //   const [showMassSettings, setShowMassSettings] = useState(false)
    

  //   const currentDate = new Date();
  //   const oneMonthAgo = new Date();
  //   oneMonthAgo.setMonth(currentDate.getMonth() - 1);

  //   const [searchTerm, setSearchTerm] = useState('');
  //   const [filteredData, setFilteredData] = useState([]); // Track filtered data

  //   const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
  //   const [pageSize, setPageSize] = useState(1000)

  //   const apiData = {
  //       token,
  //       client
  //   }

  //   useEffect(() => {
  //       const getSites = async () => {
  //         const responseData = await getPagedDevicesAPI(apiData, 5000, pageFetchedIndex, 1, 1, 0, 0, dispatch);
  //         const totalDevices = responseData[0].totalDevices["COUNT(*)"];
  //         const data = responseData[0].devices;
      
  //         const allSites = [];
  //         const offlineSites = [];
  //         const onlineSites = [];
  //         const sitesNoUsers = [];
      
  //         data.forEach((device) => {
  //           if (["AB", "ESP", "A"].includes(device.type)) {
  //             allSites.push(device);
  //             if (device.online === "NO") offlineSites.push(device);
  //             if (device.online === "YES") onlineSites.push(device);
  //             if (device.userCount === 0) sitesNoUsers.push(device);
  //           }
  //         });
      
  //         setFilteredData(allSites);
  //         setSites(allSites);
  //         setOfflineSites(offlineSites);
  //         setOnlinesites(onlineSites);
  //         setsitesNoUsers(sitesNoUsers);
      
  //         setTotalPages(Math.ceil(totalDevices / pageSize));
  //         setTotalDevices(totalDevices);
  //         setPageSize(totalDevices);
  //         setIsLoading(false);
  //       };
      
  //       getSites();
  //     }, []);

  //   const applyFilter = (filterData) => {
  //     setFilteredData(filterData); // Update filteredData based on clicked filter
  //   };

  //   useEffect(() => {
  //     const handleDeviceFilter = () => {
  //       const filtered = sites.filter((item) =>
  //         Object.values(item)
  //           .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
  //       );
  //       dataManager.setItem('controllersSearchTerm', searchTerm); // Store search term
  //       setFilteredData(filtered); // Update filtered data
  //     };
    
  //     if (searchTerm !== dataManager.getItem('controllersSearchTerm')) {
  //       handleDeviceFilter(); // Call filtering function
  //     }
  //   }, [searchTerm, sites]);
    
  //   return (
  //     <Await resolve={sites}>
  //       {(loadedSites) => {
  //         return (
  //           <>
  //           <div style={{ width: "100%"}}>
  //           <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
  //           <div
  //               onClick={() => {
  //                applyFilter(loadedSites); 
  //               }}
  //               style={{ cursor: "pointer", width:"350px"}} 
  //             >
  //             <Stats2
  //               title={"All controller count"}
  //               value={loadedSites.length}
  //               isLoadingStats={isLoading}
  //               isStatic={true}
  //             />
  //           </div>
  //           <div
  //               onClick={() => {
  //                 applyFilter(onlineSites) 
  //               }}
  //               style={{ cursor: "pointer", width:"350px" }} 
  //             >
  //             <Stats2
  //               title={"Online controllers"}
  //               value={onlineSites.length}
  //               isLoadingStats={isLoading}
  //               isStatic={true}
  //             />
  //           </div>
  //           <div
  //               onClick={() => {
  //                 applyFilter(offlineSites) 
  //               }}
  //               style={{ cursor: "pointer", width:"350px" }} 
  //             >
  //             <Stats2
  //               title={"Offline controllers "}
  //               value={offlineSites.length}
  //               isLoadingStats={isLoading}
  //               isStatic={true}
  //             />
  //           </div>
  //           <div
  //               onClick={() => {
  //                 applyFilter(sitesNoUsers) 
  //               }}
  //               style={{ cursor: "pointer", width:"350px" }} 
  //             >
  //             <Stats2
  //               title={"Controllers with no users"}
  //               value={sitesNoUsers.length}
  //               isLoadingStats={isLoading}
  //               isStatic={true}
  //             />
  //           </div>
  //         </div>

  //           <br></br>
  //           {isLoading ? (
  //             <div style={{ display: "flex", width: "100%" }}>
  //               <DeviceLoadingGrid
  //                 CardCount={
  //                   20
  //                 }
  //               />
  //             </div>
  //           ) : (
  //             <>
  //             <div className={classes.searchContainer}>
  //             <SearchBar
  //                 type="text"
  //                 placeholder="Search..."
  //                 value={searchTerm}
  //                 onChange={(e) => setSearchTerm(e.target.value)}
  //                 style={{
                    
  //                     padding: "10px", // Adjust padding to reduce height
  //                     width: "300px",    // Set a specific width
  //                     fontSize: "14px",  // Adjust font size for better proportions
  //                     boxSizing: "border-box", // Ensure consistent sizing
  //                     borderRadius: "4px", // Add slight rounding for aesthetics
                      
  //                 }}
  //             />
  //             {searchTerm !== "" && <div>
  //                 <p>{filteredData.length} results</p>
  //             </div>}
  //           </div>

  //             <DevicesList
  //               devices={filteredData}
  //               filtering={""}
  //               hideControls={false}
  //               totalPages={totalPages}
  //               setTotalPages={setTotalPages}
  //               pageFetchedIndex={pageFetchedIndex}
  //               setPageFetchedIndex={setPageFetchedIndex}
  //               pageSize={filteredData.length}
  //               setPageSize={setPageSize}
  //               totalDevices={filteredData.length}
  //               setTotalDevices={setTotalDevices}
  //               groupMode={false}
  //               update={update}
  //               setUpdate={setUpdate}
  //               offlineOnly={false}
  //               isSortable={true}
  //               showMassSelect={true}
  //               showMassSettings={showMassSettings}
  //               setShowMassSettings={setShowMassSettings}
  //             />
  //             </>
              
  //           )}
  //         </div>
  //           </>
  //         )

          

  //       }}
  //     </Await>
  //   )
  // }


export default Controllers;